// src/Context/ProductContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface ProductContextValue {
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  categoryFilter: string;
  setCategoryFilter: React.Dispatch<React.SetStateAction<string>>;
  DrawbarActive: boolean;
  setDrawbarActive: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ProductContext = createContext<ProductContextValue | null>(null);

export const ProductProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [DrawbarActive, setDrawbarActive] = useState(false);

  return (
    <ProductContext.Provider value={{
      searchQuery, setSearchQuery,
      categoryFilter, setCategoryFilter,
      DrawbarActive, setDrawbarActive,
    }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProductContext = (): ProductContextValue => {
  const ctx = useContext(ProductContext);
  if (!ctx) throw new Error('useProductContext doit être utilisé dans <ProductProvider>');
  return ctx;
};
